import { useEffect } from 'react';

import { useFeatureFlagSplit } from '@verantos-dev/core-utils';
import { LandingPage } from '@verantos-dev/el-feature-landing-page';
import {
  CurationPlatformAppId,
  useCurationPlatformFallbackAppUrl,
} from '@verantos-dev/shared-layout';

// TODO: cleanup with cp_no_access_redirect_fix ff
export const NO_ACCESS_REDIRECT_FIX_FF = 'cp_no_access_redirect_fix';

/**
 * Rendered when the signed-in user cannot open the requested Annotation Tool
 * page. A user who holds no Annotation Tool role but is entitled to another
 * Curation Platform app (e.g. an Accuracy Viewer) is sent to that app instead
 * of being told they have no access to any application.
 */
export const AnnotationToolNoAccessPage = () => {
  // TODO: cleanup with cp_no_access_redirect_fix ff
  const isRedirectEnabled = useFeatureFlagSplit(NO_ACCESS_REDIRECT_FIX_FF) as boolean;
  const fallbackAppUrl = useCurationPlatformFallbackAppUrl({
    currentAppId: CurationPlatformAppId.annotationTool,
    isEnabled: isRedirectEnabled,
  });

  useEffect(() => {
    if (fallbackAppUrl) {
      // The other app is a separate origin, so react-router's <Navigate> can't
      // reach it. replace() keeps this dead-end page out of browser history.
      window.location.replace(fallbackAppUrl);
    }
  }, [fallbackAppUrl]);

  if (fallbackAppUrl) {
    return null;
  }

  return <LandingPage apps={[]} getUrl={() => ''} />;
};
